import React from 'react';
import './maintenance.scss'

const Maintenance = () => {
    return (
        <div className='maintenance'>
            <h1>Site Maintenance</h1>
            <p>Our website is currently undergoing schedule maintenance, but will return shortly. Thank you for your patience.</p>
        </div>
    );
};

export default Maintenance;